import React from "react";
import "./style.scss";
const Input = ({
  iconRight,
  props,
  label = "",
  leftIcon,
  forEdit = false,
  onClick = () => {},
}) => {
  if (forEdit) {
    return (
      <div
        className={`input-wrapper pointer`}
        data-disabled={props.disabled}
        onClick={onClick}
      >
        {iconRight && <span className="right-icon">{iconRight()}</span>}
        {label && <label className="fs-14 lh-24 fw-600">{label}</label>}
        <input {...props} className="num pointer" disabled={true} />

        {leftIcon && <span className="left-icon">{leftIcon()}</span>}
      </div>
    );
  }
  return (
    <div
      className={`input-wrapper ${!props.disabled}`}
      data-disabled={props.disabled}
      onClick={onClick}
    >
      {iconRight && <span className="right-icon">{iconRight()}</span>}
      {label && <label className="fs-14 lh-24 fw-600">{label}</label>}
      <input {...props} className="num" />

      {leftIcon && (
        <>
          <>
            <span className="left-icon">{leftIcon()}</span>
          </>
        </>
      )}
    </div>
  );
};

export default Input;
